import React from 'react';
// nx-ignore-next-line
import { useAuth } from './hooks';
import { AuthProvider as KeycloakAuthProvider } from './keycloak';

interface AuthProviderProps {
  children: JSX.Element;
}

export function AuthProvider({ children }: AuthProviderProps) {
  return (
    <KeycloakAuthProvider>
      <WaitForAuthInit>{children}</WaitForAuthInit>
    </KeycloakAuthProvider>
  );
}

function WaitForAuthInit({ children }: AuthProviderProps) {
  const auth = useAuth();
  if (!auth.initialized) {
    return <div>Loading...</div>;
  }

  return children;
}
